module.exports = __webpack_public_path__ + "images/file_icons_v2/avi-d849ae109390ce80862e2f3770e4e914.svg";